<script>
    import Constantes from "../../Classes/Constantes";
    import {
        ItemInserir,
        Tipo,
        generateCreateTableSQL,
    } from "../../Classes/ItemInserir";
    import { permissaoUsuario } from "../../Classes/Stores";
    import AlteraDadosBasico from "../../Componentes/AlteracaoDados/AlteraDadosBasico.svelte";
    import InserirDadosBasico from "../../Componentes/InsercaoDados/InserirDadosBasico.svelte";
    export let params;
    export let id=params;
    const itens = [
        new ItemInserir({
            rotulo: "Cupom",
            nomeColuna: "codigo_cupom",
            tamanho: 100,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
         new ItemInserir({
            rotulo: "Desconto nominal",
            nomeColuna: "desconto_nominal",
            tamanho: 30,
            tipo: Tipo.DECIMAL,
            obrigatorio: false,
        }),
         new ItemInserir({
            rotulo: "Desconto percentual",
            nomeColuna: "desconto_percentual",
            tamanho: 30,
            tipo: Tipo.DECIMAL,
            obrigatorio: false,
        }),
          new ItemInserir({
            rotulo: "Quantidade máxima",
            nomeColuna: "qtd_maxima",
            tamanho: 30,
            tipo: Tipo.DECIMAL,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Obrigatório",
            nomeColuna: "obrigatorio",
            tamanho: 1,
            tipo: Tipo.TG,
            obrigatorio: false,
        }),
        
        
        new ItemInserir({
            rotulo: "Campeonato",
            nomeColuna: "id_campeonato",
            tamanho: 30,
            tipo: Tipo.SELECAO,
            obrigatorio:true,
            config_drop_down: {
                api: "consultas.php",
                parametros: {
                    query_code: "consulta_generica_livre",
                    tabela: "campeonatos",
                },
                nome_coluna_opcoes: "nome_campeonato",
                nome_coluna_saida: "id",
                filtravel: false,
                itens: "",
            },
        }),
    ];
</script>

{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_editar_cupons)}
    {#if id}
        <AlteraDadosBasico
            {id}
            strong={true}
            apiConsultaEdicao={Constantes.api_consultar_padrao}
            apiEdicao = {Constantes.api_editar_padrao}
            query_code_carregar_edicao={"carrega_dados"}
            tabela={"cupons"}
            navegar_para={Constantes.tela_cupons}
            {itens}
        />
    {:else}
        <InserirDadosBasico
            strong={true}
            api={Constantes.api_inserir_sem_query_code}
            query_code_inserir={"teste"}
            tabela={"cupons"}
            {itens}
        />
    {/if}
{/if}
